<!-- 知识库-草稿箱 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" size="small" @click="onAddItem">
        <i class="fas fa-fw fa-plus-circle" aria-hidden="true" /> 新建文章
      </el-button>

      <div class="former">
        <el-input
          v-model.trim="key"
          placeholder="请输入关键字"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-select
          v-model="tags"
          multiple
          collapse-tags
          :clearable="true"
          placeholder="请选择标签"
          filterable
        >
          <el-option
            v-for="(tag, index) in tagList"
            :key="index"
            :label="tag"
            :value="tag"
          ></el-option> </el-select
        >&nbsp;
        <el-button type="primary" size="small" @click="onSubmitQuery">
          <i class="fas fa-fw fa-search" />
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" tooltip-effect="light">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="Title" label="文章标题" />
      <el-table-column label="标签" width="200">
        <template slot-scope="{ row }">
          <el-tag
            v-for="tag in row.Tags"
            :key="tag"
            style="margin-right: 5px; color: #00b3ca"
            >{{ tag }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="CreatedUser.Name" width="100" />
      <el-table-column label="创建日期" width="100">
        <template slot-scope="{ row }">
          <span v-if="row.CreatedAt">{{
            $sys.dateFormat(row.CreatedAt, "Y-m-d")
          }}</span>
        </template> </el-table-column
      ><el-table-column
        prop="BackDesc"
        label="退回说明"
        show-overflow-tooltip
      />
      <el-table-column width="180" label="操作">
        <template slot-scope="{ row }">
          <el-button title="查看" @click.stop="onShowDetail(row)">
            <i class="fas fa-fw fa-eye" />
          </el-button>
          <el-button
            title="编辑"
            type="primary"
            @click="onEditItem(row)"
            :disabled="getDisable(row)"
          >
            <i class="fas fa-fw fa-edit" />
          </el-button>
          <el-button
            title="提交审核"
            type="warning"
            @click="onSubmitItem(row)"
            :disabled="getDisable(row)"
          >
            <i class="fa fa-check-square" />
          </el-button>
          <el-button
            title="删除"
            type="danger"
            @click.stop="onDeleteItem(row)"
            :disabled="getDisable(row)"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pull-right clearfix mar-top-10">
      <el-pagination
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>

    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :tag-list="tagList"
      @form:saved="flush"
    />
    <item-detail :value="item" :visible.sync="seeingVisible" />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";
import ItemDetail from "./view-detail.vue";

export default {
  components: {
    ItemForm,
    ItemDetail,
  },
  data() {
    return {
      group: 0, //业务组类型 0.嵌入式 1.工控
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        BusinessGroup: this.group,
        Status: 0, //状态 0:草稿.1:待审核.2:发布，必传值
      },
      tags: [],
      key: "",
      tagList: [],
      item: this.getEmptyItem(),
      itemVisible: false,
      seeingVisible: false,
      curUserID: "",
    };
  },
  created() {
    this.group = this.$route.meta.group;
    this.former.BusinessGroup = this.group;
    this.flush();
  },
  methods: {
    getDisable(row) {
      //仅创建人可编辑、提交、删除自己的文章
      this.curUserID = this.$store.state.Auth.user.ID;
      return this.curUserID !== row.CreatedUserID;
    },
    flush() {
      this.getItemList();
      this.getTagList();
    },
    getTagList() {
      this.$axios
        .get("dci/wiki/tag", {
          params: this.former,
        })
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //获取列表
    getItemList() {
      this.loading = true;
      this.$axios
        .get(this.group === 0 ? "dci/wiki/draft" : "ipc/wiki/draft", {
          params: {
            where: this.former,
            key: this.key,
            Tags: this.tags,
            ...this.pager,
            with: ["CreatedUser"],
            order: ["-created_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.querier.page = page;
      this.getItemList();
    },
    onAddItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    onEditItem(row) {
      // 因为列表不带正文内容
      this.$axios
        .get(this.group === 0 ? `dci/wiki/${row.ID}` : `ipc/wiki/${row.ID}`)
        .then((res) => {
          this.item = res.data;
          this.itemVisible = true;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    onShowDetail(row) {
      this.item = row;
      this.seeingVisible = true;
    },
    //提交
    onSubmitItem(row) {
      var arr = [row.ID];
      this.$confirm("确定要提交此文章吗？", "提示")
        .then(() =>
          this.$axios.post(
            this.group === 0
              ? `dci/wiki/draft/submit`
              : `ipc/wiki/draft/submit`,
            {
              ids: arr,
            }
          )
        )
        .then(() => {
          this.getItemList();
          this.$message.success("提交成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此文章吗？", "提示")
        .then(() =>
          this.$axios.delete(
            this.group === 0
              ? `dci/wiki/draft/${row.ID}`
              : `ipc/wiki/draft/${row.ID}`
          )
        )
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {
        Title: "", //文章标题
        WikicatID: 0, //分类id
        Content: "", //文章内容
        Attachments: [], //附件
        Tags: [], //标签
        VideoAddress: [""], //视频地址
        Status: 0, //状态 0:草稿.1:待审核.2:发布
        BusinessGroup: this.group, //业务组类型 0.嵌入式 1.工控
      };
    },
  },
};
</script>

<style lang="scss">
.wiki-part {
  .el-tree-node__content {
    position: relative;
  }
  .show-node {
    flex: 1;
    display: flex;
    align-itemlist: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 14px;
  }
  .adjust-btn {
    display: none;
    position: absolute;
    right: 15px;
  }
  .show-node:hover .adjust-btn {
    display: block;
  }
  .adjust-btn .el-button {
    margin: 0;
  }
}
.d-iblock {
  display: inline-block;
}
.standard-search {
  margin-right: 0.5em;
  .el-select {
    .el-input .el-input__inner {
      height: 28px !important;
    }
    .el-select__tags,
    .el-select__tags span {
      white-space: nowrap;
      overflow: hidden;
      flex-wrap: nowrap;
    }
  }
  vertical-align: middle;
}
</style>
